export default __webpack_public_path__ + "static/media/jap-ecommerceImg_5.c78590d4.png";